<template>
  <el-input
    :placeholder="placeValue"
    clearable
    style="width: 250px;"
    v-model="searchVal"
    @keyup.enter.native ="search"
  >
    <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
  </el-input>
</template>

<script>
export default {
  props: ['placeValue'],
  data() {
    return {
      searchVal: '',
    }
  },
  methods: {
    search() {
      this.$emit('sureSearch', this.searchVal.trim())
    },
  },
}
</script>
